<template>
  <div class="aside aside-left d-flex flex-column" id="kt_aside" ref="kt_aside">
    <!--begin::Brand-->
    <KTBrand></KTBrand>
    <!--end::Brand-->
    <!--begin::Nav Wrapper-->
    <div class="aside-nav d-flex flex-column align-items-center flex-column-fluid pt-7">
      <!--begin::Nav-->
      <ul class="nav flex-column">
        <!--begin::Item-->
        <li class="nav-item mb-5" v-b-tooltip.hover.right="'dashboard'">
          <v-btn fab small color="white" @click="nav('dashboard')" elevation="0">
            <i class="flaticon2-protection icon-lg" style="color: #130e33f5;"></i>
          </v-btn>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="nav-item mb-5" v-b-tooltip.hover.right="'eventos'">
          <v-btn fab small color="white" @click="nav('evento')" elevation="0">
            <i class="flaticon2-list-3 icon-lg" style="color: #130e33f5;"></i>
          </v-btn>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="nav-item mb-5" v-b-tooltip.hover.right="'ingressos'">
          <v-btn fab small color="white" elevation="0" @click="nav('ingressos')">
            <i class="flaticon2-calendar-6 icon-lg" style="color: #130e33f5;"></i>
          </v-btn>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="nav-item mb-5" v-b-tooltip.hover.right="'Setor'">
          <v-btn fab small color="white" @click="nav('setor')" elevation="0">
            <i class="flaticon2-hourglass-1 icon-lg" style="color: #130e33f5;"></i>
          </v-btn>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="nav-item mb-5" v-b-tooltip.hover.right="'Pontos de venda'">
          <v-btn fab small color="white" @click="nav('pdv')" elevation="0">
            <i class="flaticon2-analytics-2 icon-lg" style="color: #130e33f5;"></i>
          </v-btn>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="nav-item mb-5" v-b-tooltip.hover.right="'Finance &amp; Accounting'">
          <!--
          <v-btn
        fab
        small
        color="white"
        elevation="0"
          >
        <i class="flaticon2-medical-records-1 icon-lg" style="color: #130e33f5;"></i>
          </v-btn>
          -->
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="nav-item mb-5" v-b-tooltip.hover.right="'User Management'">
          <!--
          <v-btn
        fab
        small
        color="white"
        elevation="0"
          >
        <i class="flaticon2-gear icon-lg" style="color: #130e33f5;"></i>
          </v-btn>
          -->
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="nav-item mb-5" v-b-tooltip.hover.right="'Finance &amp; Accounting'">
          <!--
          <v-btn
        fab
        small
        color="white"
        elevation="0"
          >
        <i class="flaticon2-warning icon-lg" style="color: #130e33f5;"></i>
          </v-btn>
          -->
        </li>
        <!--end::Item-->
      </ul>
      <!--end::Nav-->
    </div>
    <!--end::Nav Wrapper-->
    <!--begin::Footer-->
    <div class="aside-footer d-flex flex-column align-items-center flex-column-auto py-8">
      <!--begin::Quick Panel-->
      <KTQuickPanel></KTQuickPanel>
      <!--end::Quick Panel-->
    </div>
    <!--end::Footer-->
  </div>
</template>

<style lang="scss">
/* hide default vue-bootstrap tab links */
.hide-tabs>div:not(.tab-content) {
  display: none;
}
</style>

<script>
import KTQuickPanel from "@/view/layout/extras/offcanvas/QuickPanel";
import KTBrand from "@/view/layout/brand/Brand";
import KTLayoutAside from "@/assets/js/layout/base/aside.js";

export default {
  name: "Aside",
  components: {
    KTQuickPanel,
    KTBrand
  },
  mounted() {
    this.$nextTick(() => {
      // Init Aside
      KTLayoutAside.init(this.$refs["kt_aside"]);
    });
  },
  methods: {
    nav(value) {
      this.$router.push({ name: value });

    }
  }
};
</script>
